var map = {
	"./music-instructions.json": 5148,
	"./music-library-intro2024.json": 5149,
	"./music-library-launch2024.json": 5150,
	"./music-progression.json": 5151,
	"./startSourcesAdvanced.json": 5152,
	"./startSourcesSimple.json": 5153,
	"./startSourcesSimple2.json": 5154,
	"./startSourcesTracks.json": 5155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4846;